import { namespace } from 'vuex-class';
import { IDeleteFieldState } from './delete-field.types';

export const DeleteField = namespace('dealroom/fields/deleteField');

export const state: IDeleteFieldState = {
  failedDeletedFields: [],
};

export enum EDeleteFieldAction {
  Reset = 'reset',
  Delete = 'delete',
  DeleteFailed = 'deleteFailed',
}

export enum EDeleteFieldMutation {
  SetFailedDeletedFields = 'setDeletedFields',
  SetState = 'setState',
}
